import { requestAPI } from '../../../../utils/request';
import {
  reportsRequest,
  reportsSuccess,
  reportsFailure,
  setDisplayReports,
  reportRequest,
  reportSuccess,
  reportFailure,
  regenerateReportRequest,
  regenerateReportSuccess,
  regenerateReportFailure,
} from './actions';
import message from '../../../../utils/message';
import { Dispatch, GetState } from '../../../../@types';
import { ReportsState } from './initialState';

export const fetchReports = () => (dispatch: Dispatch) => {
  dispatch(reportsRequest());
  requestAPI('/fleets/reports')
    .then((data) => {
      dispatch(reportsSuccess(data));
      dispatch(setDisplayReports(data));
    })
    .catch((err) => {
      message.error(err.message);
      dispatch(reportsFailure(err));
    });
};

export const fetchReportById = (reportId: string) => (dispatch: Dispatch) => {
  dispatch(reportRequest());
  requestAPI(`/fleets/reports/${reportId}`)
    .then((data) => {
      dispatch(reportSuccess(data));
    })
    .catch((err) => {
      message.error(err.message);
      dispatch(reportFailure(err));
    });
};

export const regenerateReport = (reportId: string) => (dispatch: Dispatch) => {
  dispatch(regenerateReportRequest());
  requestAPI(`/fleets/reports/${reportId}/regenerate`, {}, { method: 'PUT' })
    .then((data) => {
      dispatch(regenerateReportSuccess(data));
      message.success('Report regenerated successfully');
    })
    .catch((err) => {
      message.error(err.message);
      dispatch(regenerateReportFailure(err));
    });
};

const shouldFetchReports = (reports: ReportsState) => !reports?.loading;

export const fetchReportsIfNeeded = () => {
  return (dispatch: Dispatch, getState: GetState) => {
    if (shouldFetchReports(getState().appData.reports)) {
      return dispatch(fetchReports());
    } else {
      return Promise.resolve();
    }
  };
};
